<template>
  <detail-view
    :id="id"
    :client="client"
    :invite-client="inviteClient"
    :group-service="groupService"
    :grocery-client="groceryClient"
  />
</template>

<script lang="ts">
  import DetailView from '@/views/recipe/detail/DetailView.vue';
  import RecipeClient from '@/service/recipe/recipeClient';
  import InviteClient from '@/service/invite/inviteClient';
  import GroupService from '@/service/group/groupService';
  import GroceryClient from '@/service/groceries/groceryClient';
  import { useAuthStore } from '@/stores/auth';
  import { useFirestore } from 'vuefire';

  export default {
    name: 'DetailViewRoute',
    components: { DetailView },
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    async setup() {
      const authStore = useAuthStore();
      const firestore = useFirestore();
      const identifier = authStore.getIdentifier();
      const client = await RecipeClient.setup(identifier);
      const inviteClient = new InviteClient(firestore, identifier.uid);
      const groupService = new GroupService(firestore, identifier.uid);
      const groceryClient = await GroceryClient.setup(firestore, identifier);
      return { client, inviteClient, groupService, groceryClient };
    },
  };
</script>
